import { Tabs } from 'antd';
import { TabsType } from 'antd/lib/tabs';
import type { Tab } from 'rc-tabs/lib/interface';
import React, { ReactNode, useCallback } from 'react';
import { ReactElement } from 'react';

export default function HashTabs(props: {
    children?: ReactNode;
    defaultActiveKey: string;
    items?: Tab[];
    type?: TabsType;
}): ReactElement {
    const {
        children,
        defaultActiveKey,
        items,
        type,
    } = props;

    const onChangeTab: (activeKey: string) => void = useCallback((activeKey: string): void => {
        window.location.hash = activeKey;
    }, []);

    return (
        <Tabs
            activeKey={window.location.hash.replace('#', '') || defaultActiveKey}
            items={items}
            onChange={onChangeTab}
            type={type}
        >
            {children}
        </Tabs>
    );
}